Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='src/Placeholder.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();

var _react=require('react');var _react2=_interopRequireDefault(_react);
var _bluebird=require('bluebird');var _bluebird2=_interopRequireDefault(_bluebird);
var _fp=require('lodash/fp');
var _emitter=require('./emitter');
var _PlaceholderChild=require('./PlaceholderChild');var _PlaceholderChild2=_interopRequireDefault(_PlaceholderChild);
var _PlaceholderElement=require('./PlaceholderElement');var _PlaceholderElement2=_interopRequireDefault(_PlaceholderElement);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var









Placeholder=function(_React$Component){_inherits(Placeholder,_React$Component);






function Placeholder(props){_classCallCheck(this,Placeholder);var _this=_possibleConstructorReturn(this,(Placeholder.__proto__||Object.getPrototypeOf(Placeholder)).call(this,
props));

_this.reject=_this.reject.bind(_this);
_this.resolve=_this.resolve.bind(_this);

_emitter.emitter.addListener('updateProps',function(id,newProps){var
views=_this.state.views;

if(views[id]){
var newViews=_extends({},
views,_defineProperty({},
id,_extends({},
views[id],{
props:_extends({},
views[id].props,
newProps)})));




_this.setState({
views:newViews});

}
});

_emitter.emitter.addListener('presentView',function(id,component,initialProps,resolve,reject,onCancel,resolvers,rejecters){var
views=_this.state.views;

var onCancelInternal=void 0;

if(onCancel){
onCancel(function(){
onCancelInternal&&onCancelInternal();
initialProps.onCancel&&initialProps.onCancel();
_this.onCancel(id);
});
}

_this.setState({
views:_extends({},
views,_defineProperty({},
id,{
id:id,
component:component,
props:initialProps,
resolve:resolve,
reject:reject,
resolvers:resolvers,
rejecters:rejecters,
onCancel:function onCancel(cb){onCancelInternal=cb;}}))});



});

_this.timeouts=[];

_this.state={
views:{}};return _this;

}_createClass(Placeholder,[{key:'componentWillUnmount',value:function componentWillUnmount()

{
(0,_fp.forEach)(function(t){
t.cancel&&t.cancel();
},this.timeouts);
}},{key:'cleanUpAfterDelay',value:function cleanUpAfterDelay(

index){var _this2=this;
var timeout=_bluebird2.default.delay(this.props.cleanUpDelay||2000).then(function(){
_this2.setState({
views:(0,_fp.omit)(index,_this2.state.views)});

});
this.timeouts.push(timeout);
}},{key:'onCancel',value:function onCancel(



index){
this.cleanUpAfterDelay(index);
}},{key:'resolve',value:function resolve(

index,value){
this.state.views[index].resolve(value);
this.cleanUpAfterDelay(index);
}},{key:'reject',value:function reject(

index,reason){
this.state.views[index].reject(reason||new Error('View closed with a rejection'));
this.cleanUpAfterDelay(index);
}},{key:'render',value:function render()

{var _this3=this;
var children=(0,_fp.map)(function(_ref){var component=_ref.component,props=_ref.props,id=_ref.id,onCancel=_ref.onCancel,resolvers=_ref.resolvers,rejecters=_ref.rejecters;return(
_react2.default.createElement(_PlaceholderChild2.default,{
props:props,
component:component,
id:id,
key:id,
resolvers:resolvers,
rejecters:rejecters,
_resolve:_this3.resolve,
_reject:_this3.reject,
onCancel:onCancel,__source:{fileName:_jsxFileName,lineNumber:122}}));},

this.state.views)||[];

return _react2.default.createElement(_PlaceholderElement2.default,{__source:{fileName:_jsxFileName,lineNumber:135}},children);
}}]);return Placeholder;}(_react2.default.Component);exports.default=


Placeholder;
//# sourceMappingURL=Placeholder.js.map